import { NgbModalOptions } from '@otas/modal/modal';

export enum ProductType {
    POOJA = 'POOJA', SALE = 'SALE', MATERIAL = 'MATERIAL', NADAVARAVU = 'NADAVARAVU', SAMARPPANAM = 'SAMARPPANAM',
    SAMARPANAM = 'SAMARPANAM'
};
export class AppConstants {
    public static bgColor = '#5dbcd2';
    public static shivamBgColor = '#ffd9ad';
    public static dateFormat = 'DD/MM/YYYY';
    public static reportDateFormat = 'DD/MM/YYYY';
    public static dateTimeFormat = 'DD/MM/YYYY HH:mm:ss';
    public static _dateTimeFormat = 'DD/MM/YYYY hh:mm A';
    public static displayDateFormat = 'DD-MMM-YYYY';

    public static displayDateTimeFormat = 'dd-MM-yyyy HH:mm';
    public static momentDateFormat = 'DD-MM-YYYY';
    public static momentDateTimeFormat = 'DD-MM-YYYY HH:mm:ss';
    public static dateYearFormat = 'MMM/YYYY';
    public static newDateFormat = 'dd/mm/yyyy';
    public static fileNameDateFormat = 'dd-MM-YYYY-HH-mm-ss';
    public static loading = false;
    public static datePickerTheme = "theme-default";

    // tslint:disable-next-line:max-line-length
    public static customElements = `indic-input:not([disabled="true"]),app-multi-select:not([disabled="true"]),app-auto-suggest:not([disabled="true"])`;
    // tslint:disable-next-line:max-line-length
    public static toSearch = `select:not([id=avoid],[disabled],app-time-picker select),input:not([type=hidden],
        [placeholder="Choose date"],
        [type=checkbox],[type=radio],[disabled],
        [readOnly],app-vendor-name-panel input,app-overlay-panel input,app-panchang-calendar input,indic-input input,app-auto-suggest input,app-vendor-name-panel input), span[class=select],
        app-auto-complete:not([ng-reflect-is-disable="true"]),app-panchang-calendar:not([ng-reflect-is-disable="true"]),
        indic-input:not([ng-reflect-is-disable="true"],app-auto-complete indic-input),
        app-multi-select:not([ng-reflect-is-disable="true"]),
        app-auto-suggest:not([ng-reflect-is-disable="true"]),
        app-vendor-name-panel:not([ng-reflect-is-disable="true"])`;
    // app-auto-complete:not(app-phone-number app-auto-complete),

    public static MembershipType = [{ id: 'PERMANENT', name: 'PERMANENT' }, { id: 'TEMPORORY', name: 'TEMPORORY' }];
    public static smallModalOptions: NgbModalOptions = {
        backdrop: true,
        size: 'sm',
        keyboard: false
    };
    public static largeModaloptions: NgbModalOptions = {
        windowClass: 'animated fadeInDown', backdrop: 'static',
        size: 'lg',
        keyboard: false

    };
    public static largeModaloptionsForShivam: NgbModalOptions = {
        windowClass: 'animated fadeInDown shivam-modal', backdrop: 'static',
        size: 'lg',
        keyboard: false
    };

    public static xlargeModaloptions: NgbModalOptions = {
        windowClass: 'animated fadeInDown', backdrop: 'static',
        size: 'xlg',
        keyboard: false

    };
    public static xlargeModaloptionsForShivam: NgbModalOptions = {
        windowClass: 'animated fadeInDown shivam-modal', backdrop: 'static',
        size: 'xlg',
        keyboard: false
    };
    public static mediumModalOptions: NgbModalOptions = {
        windowClass: 'animated fadeInDown', backdrop: 'static',
        keyboard: false

    };
    public static genders = [{
        name: 'MALE'
    }, { name: 'FEMALE' }
    ];
    public static GOTRAS = ['Agastya', 'Angirasa', 'Atri', 'Bhrigu', 'Kashyapa', 'Vasistha', 'Vishvamitra'];
    public static NAKSHATRAS = [
        'Ashwathy', 'Bharani', 'Karthika', 'Rohini', 'Makayiram', 'Thiruvathira', 'Punartham',
        'Pooyam', 'Aayilyam', 'Makam', 'Pooram', 'Uthram', 'Atham',
        'Chithira', 'Chothi', 'Vishakham', 'Anizham', 'Thrikketta', 'Moolam', 'Pooradam',
        'Uthradam', 'Thiruvonam', 'Avittam', 'Chathayam', 'Pooruruttathi', 'Uttrittathi', 'Revathi',
        'Mesha', 'Mithuna', 'Simha', 'Kanya', 'Tula', 'Vrischika', 'Dhanus', 'Kumbha', 'Meena', 'Rishabha',
        'Kadaka', 'Makara', 'Aadisya', 'Agni', 'Angiras Brahmin', 'Alambayan', 'Atri', 'Awasthi', 'Bachchas', 'Bansal', 'Bhargava',
        'Bhardwaja', 'Baghel', 'Chaudhary', 'Dahiya', 'Deval', 'Dubey', 'Gangotri', 'Gautam', 'Gohel',
        'Gelot', 'Gohil', 'Gahlot', 'Goyal', 'Harita', 'Jadaun', 'Kansal', 'Kapistal', 'Kashyapa',
        'Kaundinya gotra', 'Kaushal', 'Kaushik', 'Vishwamitra/Kaushik', 'Mittal', 'Mohil/Mahiwal',
        'Mudgalya/Maudgalya/Mudgal', 'Munshi', 'Nanda', 'Panchal', 'Parashar', 'Rathod', 'Rawal',
        'Sandilya', 'Saraswat', 'Savarna', 'Shandilya', 'Shaktri/Shakti', 'Sheoran', 'Singhal',
        'Shankhyan', 'Srivatsa', 'Toppo', 'Upreti', 'Vaid', 'Vasishtha', 'Vats (clan)', 'Vishvakarman',
        'Ashwini', 'Bharani', 'Krithika', 'Rohini', 'Mrigasira', 'Aardra', 'Punarvasu', 'Pushya', 'Ashlesha', 'Makha', 'Pubba',
        'Uthra', 'Hastha', 'Chitra', 'Swathi', 'Vishaka', 'Anuradha', 'Jyesta', 'Moola', 'Purvashada', 'Uttarashada',
        'Shravana', 'Dhanistha', 'Shathabhisha', 'Purva Bhadra', 'Uttara Bhadra', 'Revathi'
    ];
    public static NAKSHATRASMALAYALAM = [
        'അശ്വതി', 'ഭരണി', 'കാർത്തിക', 'രോഹിണി', 'മകയിരം', 'തിരുവാതിര', 'പുണർതം',
        'പൂയം', 'ആയില്യം', 'മകം', 'പൂരം', 'ഉത്രം', 'അത്തം',
        'ചിത്തിര', 'ചോതി', 'വിശാഖം', 'അനിഴം', 'തൃക്കേട്ട', 'മൂലം', 'പൂരാടം',
        'ഉത്രാടം', 'തിരുവോണം', 'അവിട്ടം', 'ചതയം', 'പൂരുരുട്ടാതി', 'ഉത്രട്ടാതി', 'രേവതി'
    ];
    public static ALL_NAKSHATRAS = [
        {
            id: 1,
            ml: "അശ്വതി",
            en: "Ashwathy"
        },
        {
            id: 2,
            ml: "ഭരണി",
            en: "Bharani"
        },
        {
            id: 3,
            ml: "കാർത്തിക",
            en: "Karthika"
        },
        {
            id: 4,
            ml: "രോഹിണി",
            en: "Rohini"
        },
        {
            id: 5,
            ml: "മകയിരം",
            en: "Makayiram"
        },
        {
            id: 6,
            ml: "തിരുവാതിര",
            en: "Thiruvathira"
        },
        {
            id: 7,
            ml: "പുണർതം",
            en: "Punartham"
        },
        {
            id: 8,
            ml: "പൂയം",
            en: "Pooyam"
        },
        {
            id: 9,
            ml: "ആയില്യം",
            en: "Aayilyam"
        },
        {
            id: 10,
            ml: "മകം",
            en: "Makam"
        },
        {
            id: 11,
            ml: "പൂരം",
            en: "Pooram"
        },
        {
            id: 12,
            ml: "ഉത്രം",
            en: "Uthram"
        },
        {
            id: 13,
            ml: "അത്തം",
            en: "Atham"
        },
        {
            id: 14,
            ml: "ചിത്തിര",
            en: "Chithira"
        },
        {
            id: 15,
            ml: "ചോതി",
            en: "Chothi"
        },
        {
            id: 16,
            ml: "വിശാഖം",
            en: "Vishakham"
        },
        {
            id: 17,
            ml: "അനിഴം",
            en: "Anizham"
        },
        {
            id: 18,
            ml: "തൃക്കേട്ട",
            en: "Thrikketta"
        },
        {
            id: 19,
            ml: "മൂലം",
            en: "Moolam"
        },
        {
            id: 20,
            ml: "പൂരാടം",
            en: "Pooradam"
        },
        {
            id: 21,
            ml: "ഉത്രാടം",
            en: "Uthradam"
        },
        {
            id: 22,
            ml: "തിരുവോണം",
            en: "Thiruvonam"
        },
        {
            id: 23,
            ml: "അവിട്ടം",
            en: "Avittam"
        },
        {
            id: 24,
            ml: "ചതയം",
            en: "Chathayam"
        },
        {
            id: 25,
            ml: "പൂരുരുട്ടാതി",
            en: "Pooruruttathi"
        },
        {
            id: 26,
            ml: "ഉത്രട്ടാതി",
            en: "Uttrittathi"
        },
        {
            id: 27,
            ml: "രേവതി",
            en: "Revathi"
        }
    ]
    public static NAKSHATRAS_MALAYALAM = [
        { id: 1, name: 'അശ്വതി' },
        { id: 2, name: 'ഭരണി' },
        { id: 3, name: 'കാർത്തിക' },
        { id: 4, name: 'രോഹിണി' },
        { id: 5, name: 'മകയിരം' },
        { id: 6, name: 'തിരുവാതിര' },
        { id: 7, name: 'പുണർതം' },
        { id: 8, name: 'പൂയം' },
        { id: 9, name: 'ആയില്യം' },
        { id: 10, name: 'മകം' },
        { id: 11, name: 'പൂരം' },
        { id: 12, name: 'ഉത്രം' },
        { id: 13, name: 'അത്തം' },
        { id: 14, name: 'ചിത്തിര' },
        { id: 15, name: 'ചോതി' },
        { id: 16, name: 'വിശാഖം' },
        { id: 17, name: 'അനിഴം' },
        { id: 18, name: 'തൃക്കേട്ട' },
        { id: 19, name: 'മൂലം' },
        { id: 20, name: 'പൂരാടം' },
        { id: 21, name: 'ഉത്രാടം' },
        { id: 22, name: 'തിരുവോണം' },
        { id: 23, name: 'അവിട്ടം' },
        { id: 24, name: 'ചതയം' },
        { id: 25, name: 'പൂരുരുട്ടാതി' },
        { id: 26, name: 'ഉത്രട്ടാതി' },
        { id: 27, name: 'രേവതി' }
    ];
    public static NAKSHATRAS_ = [
        { id: 1, name: 'Ashwathy' },
        { id: 2, name: 'Bharani' },
        { id: 3, name: 'Karthika' },
        { id: 4, name: 'Rohini' },
        { id: 5, name: 'Makayiram' },
        { id: 6, name: 'Thiruvathira' },
        { id: 7, name: 'Punartham' },
        { id: 8, name: 'Pooyam' },
        { id: 9, name: 'Aayilyam' },
        { id: 10, name: 'Makam' },
        { id: 11, name: 'Pooram' },
        { id: 12, name: 'Uthram' },
        { id: 13, name: 'Atham' },
        { id: 14, name: 'Chithira' },
        { id: 15, name: 'Chothi' },
        { id: 16, name: 'Vishakham' },
        { id: 17, name: 'Anizham' },
        { id: 18, name: 'Thrikketta' },
        { id: 19, name: 'Moolam' },
        { id: 20, name: 'Pooradam' },
        { id: 21, name: 'Uthradam' },
        { id: 22, name: 'Thiruvonam' },
        { id: 23, name: 'Avittam' },
        { id: 24, name: 'Chathayam' },
        { id: 25, name: 'Pooruruttathi' },
        { id: 26, name: 'Uttrittathi' },
        { id: 27, name: 'Revathi' },
        { id: 28, name: 'Mesha' },
        { id: 29, name: 'Mithuna' },
        { id: 30, name: 'Simha' },
        { id: 31, name: 'Kanya' },
        { id: 32, name: 'Tula' },
        { id: 33, name: 'Vrischika' },
        { id: 34, name: 'Dhanus' },
        { id: 35, name: 'Kumbha' },
        { id: 36, name: 'Meena' },
        { id: 37, name: 'Rishabha' },
        { id: 38, name: 'Kadaka' },
        { id: 39, name: 'Makara' },
        { id: 40, name: 'Aadisya' },
        { id: 41, name: 'Agni' },
        { id: 42, name: 'Angiras Brahmin' },
        { id: 43, name: 'Alambayan' },
        { id: 44, name: 'Atri' },
        { id: 45, name: 'Awasthi' },
        { id: 46, name: 'Bachchas' },
        { id: 47, name: 'Bansal' },
        { id: 48, name: 'Bhargava' },
        { id: 49, name: 'Bhardwaja' },
        { id: 50, name: 'Baghel' },
        { id: 51, name: 'Chaudhary' },
        { id: 52, name: 'Dahiya' },
        { id: 53, name: 'Deval' },
        { id: 54, name: 'Dubey' },
        { id: 55, name: 'Gangotri' },
        { id: 56, name: 'Gautam' },
        { id: 57, name: 'Gohel' },
        { id: 58, name: 'Gelot' },
        { id: 59, name: 'Gohil' },
        { id: 60, name: 'Gahlot' },
        { id: 61, name: 'Goyal' },
        { id: 62, name: 'Harita' },
        { id: 63, name: 'Jadaun' },
        { id: 64, name: 'Kansal' },
        { id: 65, name: 'Kapistal' },
        { id: 66, name: 'Kashyapa' },
        { id: 67, name: 'Kaundinya gotra' },
        { id: 68, name: 'Kaushal' },
        { id: 69, name: 'Kaushik' },
        { id: 70, name: 'Vishwamitra/Kaushik' },
        { id: 71, name: 'Mittal' },
        { id: 72, name: 'Mohil/Mahiwal' },
        { id: 73, name: 'Mudgalya/Maudgalya/Mudgal' },
        { id: 74, name: 'Munshi' },
        { id: 75, name: 'Nanda' },
        { id: 76, name: 'Panchal' },
        { id: 77, name: 'Parashar' },
        { id: 78, name: 'Rathod' },
        { id: 79, name: 'Rawal' },
        { id: 80, name: 'Sandilya' },
        { id: 81, name: 'Saraswat' },
        { id: 82, name: 'Savarna' },
        { id: 83, name: 'Shandilya' },
        { id: 84, name: 'Shaktri/Shakti' },
        { id: 85, name: 'Sheoran' },
        { id: 86, name: 'Singhal' },
        { id: 87, name: 'Shankhyan' },
        { id: 88, name: 'Srivatsa' },
        { id: 89, name: 'Toppo' },
        { id: 90, name: 'Upreti' },
        { id: 91, name: 'Vaid' },
        { id: 92, name: 'Vasishtha' },
        { id: 93, name: 'Vats (clan)' },
        { id: 94, name: 'Vishvakarman' },

        { id: 95, name: 'Ashwini' }, { id: 96, name: 'Bharani' }, { id: 97, name: 'Krithika' }, { id: 98, name: 'Rohini' },
        { id: 99, name: 'Mrigasira' }, { id: 100, name: 'Aardra' }, { id: 101, name: 'Punarvasu' }, { id: 102, name: 'Pushya' },
        { id: 103, name: 'Ashlesha' }, { id: 104, name: 'Makha' }, { id: 105, name: 'Pubba' },
        { id: 106, name: 'Uthra' }, { id: 107, name: 'Hastha' }, { id: 108, name: 'Chitra' }, { id: 109, name: 'Swathi' },
        { id: 110, name: 'Vishaka' }, { id: 111, name: 'Anuradha' }, { id: 112, name: 'Jyesta' }, { id: 113, name: 'Moola' },
        { id: 114, name: 'Purvashada' }, { id: 115, name: 'Uttarashada' },
        { id: 116, name: 'Shravana' }, { id: 117, name: 'Dhanistha' }, { id: 118, name: 'Shathabhisha' }, { id: 119, name: 'Purva Bhadra' },
        { id: 120, name: 'Uttara Bhadra' }, { id: 121, name: 'Revathi' }

    ];
    public static THITHI = ['Prathama', 'Dvithiya', 'Thrithiya', 'Chathruthi', 'Panchami', 'Sashti', 'Sapthami',
        'Ashtami', 'Navami', 'Dasami', 'Ekaadasi', 'Dwaadasi', 'Thrayodasi', 'Chathurdasi', 'Pournami', 'Amavasy'];
    public static WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    public static YEAR = [
        'Chingam', 'Kanni', 'Thulam', 'Vrischikam', 'Dhanu', 'Makaram', 'Kumbham', 'Meenam',
        'Medam', 'Idavam', 'Midhunam', 'Karkitakam'
    ];
    public static rasi = ['Mesha', 'Vrishabha', 'Mithuna', 'Kataka', 'Simha', 'Kanya', 'Thula',
        'Vrichika', 'Dhanus', 'Makara', 'Kumbha', 'Meena'];
    public static stars = [
        { name: 'ASWATHY', value: 1 },
        { name: 'BHARANI', value: 2 },
        { name: 'KARTHIKA', value: 3 },
        { name: 'ROHINI', value: 4 },
        { name: 'MAKAYIRAM', value: 5 },
        { name: 'THIRUVATHIRA', value: 6 },
        { name: 'PUNARTHAM', value: 7 },
        { name: 'POOYAM', value: 8 },
        { name: 'AYILYAM', value: 9 },
        { name: 'MAKAM', value: 10 },
        { name: 'POORAM', value: 11 },
        { name: 'UTRAM', value: 12 },
        { name: 'ATHAM', value: 13 },
        { name: 'CHITHIRA', value: 14 },
        { name: 'CHOTHY', value: 15 },
        { name: 'VISHAKAM', value: 16 },
        { name: 'ANIZHAM', value: 17 },
        { name: 'TRIKETTA', value: 18 },
        { name: 'MOOLAM', value: 19 },
        { name: 'POORADAM', value: 20 },
        { name: 'UTHRADAM', value: 21 },
        { name: 'THIRUVONAM', value: 22 },
        { name: 'AVITTAM', value: 23 },
        { name: 'CHATHAYAM', value: 24 },
        { name: 'PURURUTTATHY', value: 25 },
        { name: 'UTHRITTATHY', value: 26 },
        { name: 'REVATHI', value: 27 },
        { name: 'MESHA', value: 28 },
        { name: 'MITHUNA', value: 29 },
        { name: 'SIMHA', value: 30 },
        { name: 'KANYA', value: 31 },
        { name: 'TULA', value: 32 },
        { name: 'VRISCHIKA', value: 33 },
        { name: 'DHANUS', value: 34 },
        { name: 'KUMBHA', value: 35 },
        { name: 'MEENA', value: 36 },
        { name: 'RISHABHA', value: 37 },
        { name: 'KADAKA', value: 38 },
        { name: 'MAKARA', value: 39 },
        { value: 40, name: 'Aadisya' },
        { value: 41, name: 'Agni' },
        { value: 42, name: 'Angiras Brahmin' },
        { value: 43, name: 'Alambayan' },
        { value: 44, name: 'Atri' },
        { value: 45, name: 'Awasthi' },
        { value: 46, name: 'Bachchas' },
        { value: 47, name: 'Bansal' },
        { value: 48, name: 'Bhargava' },
        { value: 49, name: 'Bhardwaja' },
        { value: 50, name: 'Baghel' },
        { value: 51, name: 'Chaudhary' },
        { value: 52, name: 'Dahiya' },
        { value: 53, name: 'Deval' },
        { value: 54, name: 'Dubey' },
        { value: 55, name: 'Gangotri' },
        { value: 56, name: 'Gautam' },
        { value: 57, name: 'Gohel' },
        { value: 58, name: 'Gelot' },
        { value: 59, name: 'Gohil' },
        { value: 60, name: 'Gahlot' },
        { value: 61, name: 'Goyal' },
        { value: 62, name: 'Harita' },
        { value: 63, name: 'Jadaun' },
        { value: 64, name: 'Kansal' },
        { value: 65, name: 'Kapistal' },
        { value: 66, name: 'Kashyapa' },
        { value: 67, name: 'Kaundinya gotra' },
        { value: 68, name: 'Kaushal' },
        { value: 69, name: 'Kaushik' },
        { value: 70, name: 'Vishwamitra/Kaushik' },
        { value: 71, name: 'Mittal' },
        { value: 72, name: 'Mohil/Mahiwal' },
        { value: 73, name: 'Mudgalya/Maudgalya/Mudgal' },
        { value: 74, name: 'Munshi' },
        { value: 75, name: 'Nanda' },
        { value: 76, name: 'Panchal' },
        { value: 77, name: 'Parashar' },
        { value: 78, name: 'Rathod' },
        { value: 79, name: 'Rawal' },
        { value: 80, name: 'Sandilya' },
        { value: 81, name: 'Saraswat' },
        { value: 82, name: 'Savarna' },
        { value: 83, name: 'Shandilya' },
        { value: 84, name: 'Shaktri/Shakti' },
        { value: 85, name: 'Sheoran' },
        { value: 86, name: 'Singhal' },
        { value: 87, name: 'Shankhyan' },
        { value: 88, name: 'Srivatsa' },
        { value: 89, name: 'Toppo' },
        { value: 90, name: 'Upreti' },
        { value: 91, name: 'Vavalue' },
        { value: 92, name: 'Vasishtha' },
        { value: 93, name: 'Vats (clan)' },
        { value: 94, name: 'Vishvakarman' },
        { id: 95, name: 'Ashwini' }, { id: 96, name: 'Bharani' }, { id: 97, name: 'Krithika' }, { id: 98, name: 'Rohini' },
        { id: 99, name: 'Mrigasira' }, { id: 100, name: 'Aardra' }, { id: 101, name: 'Punarvasu' }, { id: 102, name: 'Pushya' },
        { id: 103, name: 'Ashlesha' }, { id: 104, name: 'Makha' }, { id: 105, name: 'Pubba' },
        { id: 106, name: 'Uthra' }, { id: 107, name: 'Hastha' }, { id: 108, name: 'Chitra' }, { id: 109, name: 'Swathi' },
        { id: 110, name: 'Vishaka' }, { id: 111, name: 'Anuradha' }, { id: 112, name: 'Jyesta' }, { id: 113, name: 'Moola' },
        { id: 114, name: 'Purvashada' }, { id: 115, name: 'Uttarashada' },
        { id: 116, name: 'Shravana' }, { id: 117, name: 'Dhanistha' }, { id: 118, name: 'Shathabhisha' }, { id: 119, name: 'Purva Bhadra' },
        { id: 120, name: 'Uttara Bhadra' }, { id: 121, name: 'Revathi' }
    ];

    public static poojaProperties = [
        // { name: 'SEPARATE_RECEIPT_POOJA', value: 0 },
        // { name: 'ONE_PER_DAY_POOJA', value: 1 },
        // { name: 'ONE_PER_DAY_RESTRICTION', value: 2 },
        // { name: 'LOGICAL_ONE_PER_DAY_POOJA', value: 3 },
        // { name: 'ANY_ONE_PER_DAY_POOJA', value: 4 },
        // { name: 'ANY_ONE_PER_DAY_BLOCKED_POOJA', value: 5 },
        // { name: 'ISSUE_ITEM_RETURN_POOJA', value: 6 },
        // { name: 'PRINT_PRASADAM_TIME_IN_RECEIPT', value: 7 },
        // { name: 'YEAR_ONLY_BOOKING_POOJA', value: 8 },
        // { name: 'DUAL_DEVOTTEE_POOJA', value: 9 },
        // { name: 'STOCK_KEEPING_POOJA', value: 10 },
        // { name: 'WITHOUT_DEVOTEE_RECEIPT_POOJA', value: 11 },

        // { name: 'STAR_POOJA_FOR_YEAR', value: 12 },
        // { name: 'COST_CHANGING_POOJA', value: 13 },
        // { name: 'MAKE_NIVEDYAM_3AM', value: 14 },
        // { name: 'MAKE_NIVEDYAM_12PM', value: 15 },
        // { name: 'VIEW_IN_NIVEDYAM_LIST', value: 16 },
        { name: 'LIMIT DAILY POOJA', value: 0, code: '1' },
        { name: 'SEPERATE INVOICE POOJA', value: 1, code: '2' },
        { name: 'LIMIT EXCEED WARN ONLY', value: 2, code: '3' },
        { name: 'COST CHANGING POOJA', value: 3, code: '4' },
        { name: 'MULTIPLE DEVOTEE POOJA', value: 4, code: '5' },
        { name: 'STOCK REDUCING POOJA', value: 5, code: '6' },
        { name: 'PRINT TIME IN INVOICE', value: 6, code: '7' },
        { name: 'TIME RESTRICT TODAY POOJA', value: 7, code: '8' },
        { name: 'TIME RESTRICT TOMORROW POOJA', value: 8, code: '9' },
        { name: 'THULABHARAM', value: 9, code: '10' },
        { name: 'WITHOUT DEVOTEE POOJA', value: 10, code: '11' },
        { name: 'STAR BOOKING PACKAGE', value: 11, code: '12' },


    ];
    public static BANK_TRANSACTION_TYPE = ['OPENING', 'WITHDRAWAL', 'DEPOSIT', 'CLOSING', 'FUND_TRANSFER', 'INTEREST', 'BANK_CHARGE'];
    public static mlReplacements: Map<string, string> = new Map([
        ['`', '\u0d4d\u0d30'],
        ['~', '\u0d09'],
        ['1', '\u0D1c'],
        ['!', '\u0D05'],
        ['2', '\u0D1E'],
        ['@', '\u0D2D'],
        ['3', '\u0D1F'],
        ['#', '\u0D06'],
        ['4', '\u0D20'],
        ['$', '\u0D07'],
        ['5', '\u0D21'],
        ['%', '\u0D1E\u0D4D\u0D1C'],
        ['6', '\u0D22'],
        ['^', '\u0d02'],
        ['7', '\u0D23'],
        ['&', '\u0D28\u0D4D\u0D27'],
        ['8', '\u0D24'],
        ['*', '\u0d15'],
        ['9', '\u0D25'],
        ['(', '\u0D0F'],
        ['0', '\u0D1B'],
        [')', '\u0D12'],
        ['-', '\u0D18'],
        ['_', '\u0d43'],
        ['=', '\u0D2A'],
        ['+', '\u0d16'],
        ['q', '\u0D28\u0D4D\u0D2E'], // '\u0D90'
        ['Q', '\u0d7a'],
        ['w', '\u0d1e\u0d4d\u0d1a'], // '\u0d96'
        ['W', '\u0d41'],
        ['e', '\u0d1f\u0d4d\u0d1f'], //
        ['E', '\u0d35'],
        ['r', '\u0d24\u0d4d\u0d25'],
        ['R', '\u0d15\u0d4d\u0d37'],
        ['t', '\u0d23\u0d4d\u0d1f'],
        ['T', '\u0d3e'],
        ['y', '\u0d2e\u0d4d\u0d2a'],
        ['Y', '\u0d4d\u0d2f'], // '\u0d43'
        ['u', '\u0d26\u0d4d\u0d27'],
        ['U', '\u0d3f'], // '\u0d5f' //Ajesh
        ['i', '\u0d1e\u0d4d\u0d1e'],
        ['I', '\u0d39'],
        ['o', '\u0d26\u0d4d\u0d26'],
        ['O', '\u0d7d'],
        ['p', '\u0d31\u0d4d\u0d31'],
        ['P', '\u0d7e'],
        ['[', '\u0d46'], // '\u0d62'
        ['{', '\u0d0b'],
        [']', '\u0d57'],
        ['}', '\u0d1c\u0d4d\u0d1e'],
        ['\\', '\u0d47'],
        ['|', '\u0d03'], // '\u0d03'
        ['a', '\u0d4d'],
        ['A', '\u0d2e'],
        ['s', '\u0d28\u0d4d\u0d25'],
        ['S', '\u0d28\u0d4d\u0d26'],
        ['d', '\u0d15\u0d4d\u0d15'], // '\u0d83'
        ['D', '\u0d32'],
        ['f', '\u0d24\u0d4d\u0d24'],
        ['F', '\u0d36'],
        ['g', '\u0d2a\u0d4d\u0d2a'],
        ['G', '\u0d37'],
        ['h', '\u0d19\u0d4d\u0d19'],
        ['H', '\u0d38'],
        ['j', '\u0d23\u0d4d\u0d23'],
        ['J', '\u0d33'],
        ['k', '\u0d28\u0d4d\u0d28'],
        ['K', '\u0d34'],
        ['l', '\u0d2e\u0d4d\u0d2e'],
        ['L', '\u0d31'],
        [';', '\u0d27'],
        [':', '\u0d26'],
        ['\'', '\u0D7B\u0d4d\u0d31'],
        ['"', '\u0d0e'],
        ['z', '\u0d1d'],
        ['Z', '\u0d4d\u0d35'],
        ['x', '\u0d28\u0d4d\u0d24'],
        ['X', '\u0d42'],
        ['c', '\u0D4D\u0D32'], // \u0D4D\u0D32     //\u0d53
        ['C', '\u0d30'],
        ['v', '\u0d19\u0d4d\u0d15'],
        ['V', '\u0d40'],
        ['b', '\u0d52'],
        ['B', '\u0d2f'],
        ['n', '\u0d2f\u0d4d\u0d15\u0d4d\u0d15'],
        ['N', '\u0d7b'],
        ['m', '\u0d33\u0d4d\u0d33'],
        ['M', '\u0d7c'],
        [',', '\u0d17'],
        ['<', '\u0d28'],
        ['.', '\u0d19'],
        ['>', '\u0d2b'],
        ['/', '\u0d1a'],
        ['?', '\u0d2c'],
    ]);
    public static datePickerOptions = {
        hasClearButton: false,
        autoclose: true,
        format: AppConstants.displayDateFormat,
        icon: 'fa fa-calendar',
        keyboardNavigation: true,
        disableTouchKeyboard: true,
        todayHighlight: true,
        theme: AppConstants.datePickerTheme,
        showWeekNumbers: false
    };

    public static reportDatePickerOptions = {
        hasClearButton: false,
        autoclose: true,
        format: AppConstants.displayDateFormat,
        icon: 'fa fa-calendar',
        keyboardNavigation: false,
        disableTouchKeyboard: true,
        todayHighlight: true,
        theme: AppConstants.datePickerTheme,
        showWeekNumbers: false
    };

    public static datePickerMinimalOptions = {
        hasClearButton: true,
        autoclose: true,
        format: AppConstants.newDateFormat,
        hideIcon: true,
        keyboardNavigation: true,
        disableTouchKeyboard: true,
        todayHighlight: true,
        showWeekNumbers: false
    };

    public static datePickerWithTimeOptions = {
        hasClearButton: false,
        autoclose: true,
        format: AppConstants.dateTimeFormat,
        icon: 'fa fa-calendar',
        keyboardNavigation: true,
        disableTouchKeyboard: true,
        todayHighlight: true,
        withTimepicker: true,
        rangeInputFormat: 'MMMM Do YYYY, h:mm:ss a',
        dateInputFormat: 'MMMM Do YYYY, h:mm:ss a',
        keepDatepickerOpened: true,
        showWeekNumbers: false
    };

    public static paymentDatePickerOptions = {
        hasClearButton: true,
        autoclose: true,
        format: AppConstants.displayDateFormat,
        icon: 'fa fa-calendar',
        keyboardNavigation: true,
        disableTouchKeyboard: true,
        todayHighlight: true,
        startDate: new Date(),
        endDate: new Date(),
        showWeekNumbers: false
    };

    public static salaryDatePickerOptions = {
        hasClearButton: false,
        autoclose: true,
        format: this.dateYearFormat,
        minViewMode: 1,
        icon: 'fa fa-calendar',
        keyboardNavigation: true,
        disableTouchKeyboard: true,
        todayHighlight: true,
        showWeekNumbers: false,
        viewMode: 'months',
        minMode: 'month',
    };

    public static datePickerOptionsForPoojabooking = {
        autoclose: true,
        format: AppConstants.newDateFormat,
        icon: 'fa fa-calendar',
        keyboardNavigation: true,
        disableTouchKeyboard: true,
        todayHighlight: true,
        defaultViewDate: new Date(),
        showWeekNumbers: false
    };

    public static yearPickerOptions = {
        autoclose: true,
        format: AppConstants.dateYearFormat,
        icon: 'fa fa-calendar',
        keyboardNavigation: true,
        disableTouchKeyboard: true,
        viewMode: 'years',
        minViewMode: 'years',
        showWeekNumbers: false
    };

    public static monthPickerOptions = {
        autoclose: true,
        format: AppConstants.dateYearFormat,
        icon: 'fa fa-calendar',
        keyboardNavigation: false,
        disableTouchKeyboard: true,
        viewMode: 'months',
        minMode: 'month',
        theme: AppConstants.datePickerTheme,
        showWeekNumbers: false
    };

    public static timPickerOptions = {
        icon: 'fa fa-clock-o',
        icons: { up: 'fa fa-chevron-up', down: 'fa fa-chevron-down' }
    };



    public static NOTIFICATIONS = [
        { id: 1, name: 'SMS_INVOICE' },
        { id: 2, name: 'EMAIL_INVOICE' },
        { id: 3, name: 'WHATSAPP_INVOICE' },
        { id: 4, name: 'SMS_REMAINDER' },
        { id: 5, name: 'EMAIL_REMAINDER' },
        { id: 6, name: 'WHATSAPP_REMAINDER' }
    ];
    static ProductType: any;
    static shivamUrl: string[] = ['/pooja-booking', '/accommodation']

    static isShivamRoute(url: string): boolean {
        return AppConstants.shivamUrl.some((u) => url.startsWith(u));
    }


    static checkHostType(input: string) {
        try {
            const url = new URL(input.startsWith('http') ? input : 'http://' + input);
            const host = url.hostname;

            if (host === 'localhost' || host === '127.0.0.1') {
                return 'LOCALHOST';
            }

            const ipRegex = /^(?:\d{1,3}\.){3}\d{1,3}$/;
            if (ipRegex.test(host)) {
                return 'IP';
            }

            return 'DOMAIN';

        } catch (e) {
            return 'INVALID';
        }
    }

}

export const NAKSATRAS = [
    { id: 0, en: 'ALL', ml: 'ALL' },
    { id: 1, en: 'Ashwathy', ml: 'അശ്വതി' },
    { id: 2, en: 'Bharani', ml: 'ഭരണി' },
    { id: 3, en: 'Karthika', ml: 'കാർത്തിക' },
    { id: 4, en: 'Rohini', ml: 'രോഹിണി' },
    { id: 5, en: 'Makayiram', ml: 'മകയിരം' },
    { id: 6, en: 'Thiruvathira', ml: 'തിരുവാതിര' },
    { id: 7, en: 'Punartham', ml: 'പുണർതം' },
    { id: 8, en: 'Pooyam', ml: 'പൂയം' },
    { id: 9, en: 'Aayilyam', ml: 'ആയില്യം' },
    { id: 10, en: 'Makam', ml: 'മകം' },
    { id: 11, en: 'Pooram', ml: 'പൂരം' },
    { id: 12, en: 'Uthram', ml: 'ഉത്രം' },
    { id: 13, en: 'Atham', ml: 'അത്തം' },
    { id: 14, en: 'Chithira', ml: 'ചിത്തിര' },
    { id: 15, en: 'Chothi', ml: 'ചോതി' },
    { id: 16, en: 'Vishakham', ml: 'വിശാഖം' },
    { id: 17, en: 'Anizham', ml: 'അനിഴം' },
    { id: 18, en: 'Thrikketta', ml: 'തൃക്കേട്ട' },
    { id: 19, en: 'Moolam', ml: 'മൂലം' },
    { id: 20, en: 'Pooradam', ml: 'പൂരാടം' },
    { id: 21, en: 'Uthradam', ml: 'ഉത്രാടം' },
    { id: 22, en: 'Thiruvonam', ml: 'തിരുവോണം' },
    { id: 23, en: 'Avittam', ml: 'അവിട്ടം' },
    { id: 24, en: 'Chathayam', ml: 'ചതയം' },
    { id: 25, en: 'Pooruruttathi', ml: 'പൂരുരുട്ടാതി' },
    { id: 26, en: 'Uttrittathi', ml: 'ഉത്രട്ടാതി' },
    { id: 27, en: 'Revathi', ml: 'രേവതി' },
    { id: 28, en: 'Mesha', ml: 'Mesha' },
    { id: 29, en: 'Mithuna', ml: 'Mithuna' },
    { id: 30, en: 'Simha', ml: 'Simha' },
    { id: 31, en: 'Kanya', ml: 'Kanya' },
    { id: 32, en: 'Tula', ml: 'Tula' },
    { id: 33, en: 'Vrischika', ml: 'Vrischika' },
    { id: 34, en: 'Dhanus', ml: 'Dhanus' },
    { id: 35, en: 'Kumbha', ml: 'Kumbha' },
    { id: 36, en: 'Meena', ml: 'Meena' },
    { id: 37, en: 'Rishabha', ml: 'Rishabha' },
    { id: 38, en: 'Kadaka', ml: 'Kadaka' },
    { id: 39, en: 'Makara', ml: 'Makara' }

];
export const WEEKDAYS = [
    { ml: 'ഞായർ', en: 'Sunday' },
    { ml: 'തിങ്കൾ', en: 'Monday' },
    { ml: 'ചൊവ്വ', en: 'Tuesday' },
    { ml: 'ബുധൻ', en: 'Wednesday' },
    { ml: 'വ്യാഴം', en: 'Thursday' },
    { ml: 'വെള്ളി', en: 'Friday' },
    { ml: 'ശനി', en: 'Saturday' }
];
export const ML_MONTHS = [
    { en: 'Chingam', ml: 'ചിങ്ങം' },
    { en: 'Kanni', ml: 'കന്നി' },
    { en: 'Thulam', ml: 'തുലാം' },
    { en: 'Vrischikam', ml: 'വൃശ്ചികം' },
    { en: 'Dhanu', ml: 'ധനു' },
    { en: 'Makaram', ml: 'മകരം' },
    { en: 'Kumbham', ml: 'കുംഭം' },
    { en: 'Meenam', ml: 'മീനം' },
    { en: 'Medam', ml: 'മേടം' },
    { en: 'Idavam', ml: 'ഇടവം' },
    { en: 'Mithunam', ml: 'മിഥുനം' },
    { en: 'Karkitakam', ml: 'കർക്കടകം' }];
export const EN_MONTHS = [
    { id: 0, en: 'January', ml: 'ജനുവരി', range: 31 },
    { id: 1, en: 'February', ml: 'ഫെബ്രുവരി', range: 29 },
    { id: 2, en: 'March', ml: 'മാർച്ച്‌', range: 31 },
    { id: 3, en: 'April', ml: 'ഏപ്രിൽ ', range: 30 },
    { id: 4, en: 'May', ml: 'മെയ്‌', range: 31 },
    { id: 5, en: 'June', ml: 'ജൂണ്‍', range: 30 },
    { id: 6, en: 'July', ml: 'ജൂലൈ', range: 31 },
    { id: 7, en: 'August', ml: 'ഓഗസ്റ്റ്‌', range: 31 },
    { id: 8, en: 'September', ml: 'സെപ്റ്റംബർ', range: 30 },
    { id: 9, en: 'October', ml: 'ഒക്ടോബർ', range: 31 },
    { id: 10, en: 'November', ml: 'നവംബർ', range: 30 },
    { id: 11, en: 'December', ml: 'ഡിസംബർ', range: 31 }
];

export const TITHI =
    [{ id: 1, en: 'Prathama', ml: 'പ്രഥമ' },
    { id: 2, en: 'Dwithiya', ml: 'ദ്വിതീയ' },
    { id: 3, en: 'Thrithiya', ml: 'തൃതിയ' },
    { id: 4, en: 'Chathruthi', ml: 'ചതുർത്ഥി ' },
    { id: 5, en: 'Panchami', ml: 'പഞ്ചമി' },
    { id: 6, en: 'Sashti', ml: 'ഷഷ്ഠി' },
    { id: 7, en: 'Sapthami', ml: 'സപ്തമി' },
    { id: 8, en: 'Ashtami', ml: 'അഷ്ടമി' },
    { id: 9, en: 'Navami', ml: 'നവമി' },
    { id: 10, en: 'Dasami', ml: 'ദശമി' },
    { id: 11, en: 'Ekaadasi', ml: 'ഏകാദശി' },
    { id: 12, en: 'Dwaadasi', ml: 'ദ്വാദശി' },
    { id: 13, en: 'Thrayodasi', ml: 'ത്രയോദശി' },
    { id: 14, en: 'Chathurdasi', ml: 'ചതുർദശി' },
    { id: 15, en: 'Pournami', ml: 'പൗർണ്ണമി' },
    { id: 16, en: 'Amavasya', ml: 'അമാവാസി' }
    ];

// ONLINE POOJA PAYMENT MODAL CONFIGURATIONS

export const ALL_BANKS = [
    { code: 'INDBR', name: 'IndusInd Bank' },
    { code: 'RATNR', name: 'RBL Bank' },
    { code: 'IDFBR', name: 'IDFC FIRST Bank' },
    { code: 'BARBR', name: 'Bank of Baroda' },
    { code: 'PUNBR', name: 'Punjab National Bank' },
    { code: 'BKIDR', name: 'Bank of India' },
    { code: 'UBINR', name: 'Union Bank of India' },
    { code: 'CBINR', name: 'Central Bank of India' },
    { code: 'IBKLR', name: 'IDBI Bank' },
    { code: 'JAKAR', name: 'Jammu and Kashmir Bank' },
    { code: 'KARBR', name: 'Karnataka Bank' },
    { code: 'KVBLR', name: 'Karur Vysya Bank' },
    { code: 'BDBLR', name: 'Bandhan Bank' },
    { code: 'IDIBR', name: 'Indian Bank' },
    { code: 'IOBAR', name: 'Indian Overseas Bank' },
    { code: 'CIUBR', name: 'City Union Bank' },
    { code: 'SCBLR', name: 'Standard Chartered Bank' },
    { code: 'UCBAR', name: 'UCO Bank' },
    { code: 'TMBLR', name: 'Tamilnad Mercantile Bank' },
    { code: 'DLXBR', name: 'Dhanlaxmi Bank' },
    { code: 'CSBKR', name: 'CSB Bank' },
    { code: 'DCBLR', name: 'DCB Bank' },
    { code: 'ESFBR', name: 'Equitas Small Finance Bank' },
    { code: 'AUBLR', name: 'AU Small Finance Bank' },
    { code: 'AIRPR', name: 'Airtel Payments Bank' },
    { code: 'JIOPR', name: 'Jio Payments Bank' },
    { code: 'MAHBR', name: 'Bank of Maharashtra' },
    { code: 'SIBLR', name: 'South Indian Bank' }
];

export const SUGGESTED_BANKS = [
    { code: 'ICICR', name: 'ICICI Bank' },
    { code: 'KKBKR', name: 'Kotak Mahindra Bank' },
    { code: 'FDRLR', name: 'Federal Bank' },
    { code: 'YESBR', name: 'Yes Bank' },
    { code: 'CNRBR', name: 'Canara Bank' }
];

export const ACTIVE_WALLETS = [
    { code: 'phonepe', name: 'PhonePe', icon: '📱' },
    { code: 'amazon', name: 'Amazon Pay', icon: '🛒' },
    { code: 'airtel', name: 'Airtel Money', icon: '📡' },
    { code: 'mobikwik', name: 'MobiKwik', icon: '💳' },
    { code: 'ola', name: 'Ola Money', icon: '🚗' }
];
export const CASHFREE_STYLE = {
    base: {
        fontSize: '16px',
        color: '#12213d',
        fontFamily: 'Inter, sans-serif'
    }
};

export const SUPPORT_PHONE = '+91 99473 88133';
